import { useEffect, useState } from "react";
import { playZapSound } from "../lib/zapSound";

const ZAP_MS = 2000;

/**
 * 2-second CRT "channel change" jingle drawn over a player: power-on line,
 * static snow, then the channel label — replays whenever `zapKey` changes.
 */
export const ChannelZap = ({ zapKey, name, number, color = "#f0b429" }) => {
  const [dismissed, setDismissed] = useState(null);

  useEffect(() => {
    if (zapKey == null) return undefined;
    playZapSound();
    const id = setTimeout(() => setDismissed(zapKey), ZAP_MS);
    return () => clearTimeout(id);
  }, [zapKey]);

  if (zapKey == null || dismissed === zapKey) return null;

  return (
    <div key={zapKey} className="zap-overlay" data-testid="channel-zap" aria-hidden="true">
      <div className="zap-static" style={{ "--zap-color": color }} />
      <div className="zap-line" />
      <div className="zap-label">
        <span className="zap-ch">CH {String(number ?? 0).padStart(2, "0")}</span>
        <span className="zap-name">{name}</span>
      </div>
      <div className="zap-corner">STEREO · AUTO</div>
    </div>
  );
};
